/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * List of tour operator code and name
 */
export enum TourOperatorCode {
  KU = 'KU',
  ST = 'ST',
  AL = 'AL',
  TM = 'TM',
  MI = 'MI'
}

